// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"369":"c106d5fa","568":"c106d5fa"}[chunkId] + ".chunk.css";
};